import { render, staticRenderFns } from "./Inicio.vue?vue&type=template&id=0ea156c4&scoped=true&"
import script from "./Inicio.vue?vue&type=script&lang=js&"
export * from "./Inicio.vue?vue&type=script&lang=js&"
import style0 from "./Inicio.vue?vue&type=style&index=0&id=0ea156c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea156c4",
  null
  
)

export default component.exports